import { render } from "./DataSetEditList.vue?vue&type=template&id=6685733c"
import script from "./DataSetEditList.vue?vue&type=script&lang=js"
export * from "./DataSetEditList.vue?vue&type=script&lang=js"

import "./DataSetEditList.vue?vue&type=style&index=0&id=6685733c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__